// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { logoStyles } from "@insite/content-library/Widgets/BrandDetails/BrandDetailsLogo";
import { css } from "styled-components";

logoStyles.container = {
    css: css`
        ${({ fields, brand }: any) => css`
            ${fields.showLogo &&
            brand.logoLargeImagePath &&
            css`
                margin-bottom: 16px;
            `};
        `}
    `,
};

logoStyles.heading = {
    variant: "h1",
    css: css`
        margin-bottom: 24px;
    `,
};

logoStyles.image = {
    height: "268px",
    width: "268px",
    css: css`
        max-width: 268px;
        display: block;
        img {
            width: 100%;
            height: auto;
        }
    `,
};
